import { emptySplitApi } from 'shared/store/store'
import { IFeedbackPostModel } from './Model'
import { axiosErrorMessageHelper } from 'shared/utils/axiosErrorMessageHelper'
const baseUrl = 'feedback/Feedback'

const feedbackService = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    postFeedback: build.mutation<string, Partial<IFeedbackPostModel>>({
      async queryFn(payload, _api, _extra, query) {
        const bblCode = window.config.bblCode

        const result = await query({
          url: baseUrl,
          method: 'POST',
          data: {
            application: 'Portal',
            affiliateRefId: bblCode,
            user: 'Anonymous',
            additionalProperties: payload.additionalProperties,
          },
          headers: {
            'x-api-version': '1.0',
          },
        })

        if (result.error) {
          return {
            error: axiosErrorMessageHelper(result.error, {
              fallbackError:
                'Det skjedde en feil ved sending av tilbakemelding',
            }),
          }
        }

        return { data: 'OK' }
      },
    }),
  }),
})

export const { usePostFeedbackMutation } = feedbackService

export default feedbackService
